export enum EAmplitudeEventsMinisitesLanding {
  MINISITES_LANDING_PAGE_VIEW = 'minisitiosLandingPage_view',
  MINISITES_VIEW_SELECTED = 'minisitiosTusitioweb_selected',
  MINISITES_START_NOW_SELECTED = 'minisitiosLandingStartNow_selected',
  MINISITES_EXPLORE_TEMPLATES_SELECTED = 'minisitiosExploreNewTemplates_selected',
  MINISITES_GO_NOW_SELECTED = 'minisitiosLandingGoNow_selected'
}
